import axios, { AxiosResponse } from "axios";
import { BaseResponse } from "../common/interfaces/responses";
import { getErrorMsg } from "../common/utils/request";

declare var pm: PmInterface;

function trackCount(adId: number, actionType: string) {
	if (!adId || !actionType) return;

	const formData = new FormData();

	formData.append("action", "pm_track_ads_stat");
	formData.append("nonce", pm.nonces.trackSpcStat);
	formData.append("ads_id", adId.toString());
	formData.append("action_type", actionType);

	axios({
		method: "post",
		url: pm.ajaxurl,
		data: formData,
	})
		.then((axiosResponse: AxiosResponse<any>) => {
			const response: BaseResponse = axiosResponse.data;

			if (!response || !response.success) {
				const errorMsg = getErrorMsg(axiosResponse);
				console.error(errorMsg);
				return;
			}
		})
		.catch((response: AxiosResponse<any>) => {
			const errorMsg = getErrorMsg(response);
			console.error(errorMsg);
		})
		.then(() => {});
}

export default trackCount;
